<template>
    <div class="top-notification hidemobole" v-if="totalPrice > 0">
        <h3>
            Gefeliciteerd! De meest voordelige {{ cabinType }} is beschikbaar
        </h3>
        <p>
            Wij kunnen deze hut een beperkte tijd aanbieden. Je kunt in een paar
            simpele stappen deze cruise online boeken waarmee je gegarandeerd
            bent van de prijs.<br />
            <b>Je kunt binnen 5 minuten je cruise vakantie geboekt hebben!</b>
            Heb je hulp nodig bij het online boeken? Bel dan met een van onze
            cruise specialisten op
            <a href="tel:010 7200 500">010 - 7 200 500</a>
        </p>
    </div>
</template>

<script>
export default {
    name: 'CongratulationsBanner',
    props: {
        totalPrice: Number,
        cabinType: String,
    },
}
</script>

<style lang="scss" scoped>
.top-notification {
    margin: 0 20px !important;
    background-color: #dff6e1;
    padding: 15px;

    p {
        margin-top: 5px !important;
    }

    h3,
    p {
        color: #2f7000 !important;
        margin: 0;
    }
}
@media screen and (max-width: 991px) {
  .hidemobole {
    display:none;
  }
}
</style>
